<template>
  <b-modal centered :id="dialogId" modal-class="overflow-hidden" size="lg" static>
    <template #modal-header="{ close }">
      <h5 class="modal-title">Bảng chọn CTV</h5>
      <button type="button" class="close" @click="close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Tên CTV</label>
      <div class="col-sm-7">
        <input
          type="text"
          v-model.trim="search.name"
          class="form-control"
          @keyup.enter="getListAgent()"
        />
      </div>
      <button class="btn btn-success btn-primary" @click="getListAgent()">Tìm kiếm</button>
    </div>
    <b-table
      ref="select-merchant-table"
      style="max-height: 55vh"
      :fields="fields"
      :busy.sync="loading"
      sticky-header
      responsive
      hover
      bordered
      selectable
      select-mode="single"
      :items="dataListMC"
      @row-selected="onRowSelected"
    >
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template #table-busy>
        <div class="my-2 text-center">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
    </b-table>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </b-modal>
</template>

<script>
  import { AgentService } from '@/services/agent.service'
  export default {
    props: {
      dialogId: {
        type: String,
        default: 'select-agent-dialog',
      },
    },
    data() {
      return {
        fields: [
          {
            key: 'selected',
            label: '',
            tdClass: 'text-center',
            thStyle: 'min-width: 30px',
          },
          { key: 'name', label: 'Tên' },
          { key: 'mobile', label: 'Số điện thoại' },
          { key: 'email', label: 'email' },
        ],
        dataListMC: [],
        search: {
          limit: 20,
          page: 1,
        },
        loading: false,
        total: 0,
        disabled: true,
        selectedMC: [],
        selected: null,
      }
    },

    watch: {
      'search.page': function () {
        this.getListAgent()
      },
    },

    created() {
      this.getListAgent()
    },

    methods: {
      onRowSelected(items) {
        this.disabled = !(items.length > 0)
        this.selected = items.length > 0 ? items[0] : null
        this.$emit('selectAgent', this.selected)
        this.$bvModal.hide(this.dialogId)
      },
      async getListAgent() {
        try {
          this.loading = true
          if (this.search.name === '') delete this.search.name
          const response = await AgentService.getListAgent(this.search)
          if (response.code === 1000) {
            this.dataListMC = response.data
            this.total = response.meta?.pagination?.total ?? 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped></style>
